import axios from 'axios'

/**
 * initial state
 */
const state = () => ({
  user_info: {
    role: localStorage.getItem('user_role') || '',
  },
})

/**
 * getters
 */
const getters = {
  /**
   * Get user role
   * @param {*} state
   * @returns {string}
   */
  getRole(state) {
    return state.user_info.role
  },

  /**
   * Check if user has a specific role
   * @param {*} state
   * @returns {Function}
   */
  hasRole(state) {
    return (role) => state.user_info.role === role
  },

  /**
   * Get user info
   * @param {*} state
   * @returns {Object}
   */
  userInfo(state) {
    return state.user_info
  },
}

/**
 * mutations
 */
const mutations = {
  /**
   * Set user info
   * @param {*} state
   * @param {*} data
   */
  setUserInfo(state, data) {
    state.user_info.role = data.role || ''
    localStorage.setItem('user_role', state.user_info.role)
  },

  /**
   * Destroy user info
   * @param {*} state
   */
  destroyUser(state) {
    state.user_info.role = ''
    localStorage.removeItem('user_role')
  },
}

/**
 * actions
 */
const actions = {
  /**
   * Fetch user role after login
   * @param {*} context
   * @returns {Promise}
   */
  fetchUserRole(context) {
    return new Promise((resolve, reject) => {
      axios
        .post(process.env.VUE_APP_OAUTH_AUTH, {})
        .then(function (response) {
          if (response.data.isSuccess) {
            const userInfo = {
              role: response.data.data.role,
            }
            context.commit('setUserInfo', userInfo)
            resolve(response)
          } else {
            reject(response.data.message)
          }
        })
        .catch(function (error) {
          console.log(error)
          reject(error)
        })
    })
  },

  /**
   * Destroy user info
   * @param {*} context
   */
  destroyUser(context) {
    context.commit('destroyUser')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
